import createReducer from 'shared/utils/createReducer';

import { SET_DEEP_LINK, RESET_DEEP_LINK } from '../actions/deepLink';

const defaultState = {
  deepLink: null,
  search: null,
};

export default createReducer(defaultState, {
  [SET_DEEP_LINK]: (state, { deepLink, search }) => ({
    ...state,
    deepLink,
    search,
  }),

  [RESET_DEEP_LINK]: () => defaultState,
});
